import { apis } from 'ui-common'

export default {
  submitThorntons: ({ info }: any) => apis.$post('/thortons', info)
}
